/* Gallery: swipeable scroll-snap carousel, thumbs synced both ways */
var galleryMain = document.getElementById('GalleryMain');
var galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
function setActiveThumb(i) {
  galleryThumbs.forEach(function (t) {
    t.classList.toggle('is-active', t.dataset.thumb === String(i));
  });
}
galleryThumbs.forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    var i = parseInt(thumb.dataset.thumb, 10);
    if (galleryMain) {
      galleryMain.scrollTo({ left: i * galleryMain.clientWidth, behavior: 'smooth' });
    }
    setActiveThumb(i);
  });
});
if (galleryMain) {
  var scrollTimer;
  galleryMain.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      setActiveThumb(Math.round(galleryMain.scrollLeft / galleryMain.clientWidth));
    }, 80);
  }, { passive: true });
}

/* Bundle tier selection -> quantity + sticky bar price */
var qtyInput = document.getElementById('BundleQty');
var stickyPriceEl = document.querySelector('[data-sticky-price]');
function syncStickyPrice() {
  var sel = document.querySelector('[data-tier].is-selected');
  if (sel && stickyPriceEl && sel.dataset.priceLabel) {
    stickyPriceEl.textContent = sel.dataset.priceLabel;
  }
}
document.querySelectorAll('[data-tier]').forEach(function (tier) {
  tier.addEventListener('click', function () {
    document.querySelectorAll('[data-tier]').forEach(function (t) { t.classList.remove('is-selected'); });
    tier.classList.add('is-selected');
    tier.querySelector('input[type="radio"]').checked = true;
    if (qtyInput) qtyInput.value = tier.dataset.qty;
    syncStickyPrice();
  });
});
syncStickyPrice();

/* Evergreen countdown timer (persists per visitor via localStorage) */
document.querySelectorAll('[data-timer]').forEach(function (el) {
  var minutes = parseInt(el.dataset.minutes || '480', 10);
  var key = 'bundle-timer-end';
  var end = parseInt(localStorage.getItem(key) || '0', 10);
  if (!end || end < Date.now()) {
    end = Date.now() + minutes * 60 * 1000;
    localStorage.setItem(key, String(end));
  }
  var display = el.querySelector('[data-timer-display]');
  function tick() {
    var left = Math.max(0, end - Date.now());
    if (left === 0) { // restart for evergreen effect
      end = Date.now() + minutes * 60 * 1000;
      localStorage.setItem(key, String(end));
      left = end - Date.now();
    }
    var h = Math.floor(left / 3600000);
    var m = Math.floor((left % 3600000) / 60000);
    var s = Math.floor((left % 60000) / 1000);
    display.textContent =
      String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
  }
  tick();
  setInterval(tick, 1000);
});

/* Sticky add-to-cart bar */
var stickyBar = document.querySelector('[data-sticky-atc]');
var mainForm = document.getElementById('ProductForm');
if (stickyBar && mainForm) {
  var atcBtn = mainForm.querySelector('button[name="add"]');
  window.addEventListener('scroll', function () {
    var rect = atcBtn.getBoundingClientRect();
    stickyBar.classList.toggle('is-visible', rect.bottom < 0);
  }, { passive: true });
  var stickySubmit = stickyBar.querySelector('[data-sticky-submit]');
  stickySubmit.addEventListener('click', function () {
    mainForm.requestSubmit ? mainForm.requestSubmit(atcBtn) : atcBtn.click();
  });
}
